import React from 'react';
import { InstagramIcon, TwitterIcon, LinkedinIcon, YoutubeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black border-t border-white/5 pt-20 pb-10" data-id="element-164">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-165">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-166">
          <div className="md:col-span-2" data-id="element-167">
            <img src="https://cdn.magicpatterns.com/uploads/hMbwXN9QFw6Y833Vj9bN6y/LOGO_ELEMENTAL_NEW.png" alt="Elemental Shop" className="h-10 w-auto mb-4 brightness-0 invert" data-id="element-168" />
            <p className="text-muted text-sm max-w-xs leading-relaxed" data-id="element-169">
              The ultimate AI productivity system for ambitious professionals.
              Work smarter, not harder.
            </p>
          </div>

          <div data-id="element-170">
            <h4 className="text-offwhite font-bold mb-6 text-sm uppercase tracking-widest" data-id="element-171">
              Product
            </h4>
            <ul className="space-y-4 text-sm text-muted" data-id="element-172">
              <li data-id="element-173">
                <a href="#whats-inside" className="hover:text-gold transition-colors" data-id="element-174">
                  What's Inside
                </a>
              </li>
              <li data-id="element-175">
                <a href="#bonuses" className="hover:text-gold transition-colors" data-id="element-176">
                  Bonuses
                </a>
              </li>
              <li data-id="element-177">
                <a href="#reviews" className="hover:text-gold transition-colors" data-id="element-178">
                  Reviews
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-179">
            <h4 className="text-offwhite font-bold mb-6 text-sm uppercase tracking-widest" data-id="element-180">
              Legal
            </h4>
            <ul className="space-y-4 text-sm text-muted" data-id="element-181">
              <li data-id="element-182">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-183">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-184">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-185">
                  Refund Policy
                </a>
              </li>
              <li data-id="element-186">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-187">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-188">
          <p className="text-xs text-muted" data-id="element-189">
            © {new Date().getFullYear()} Elemental Shop. All rights reserved.
          </p>
          <div className="flex items-center gap-6" data-id="element-190">
            <a href="#" className="text-muted hover:text-gold transition-colors" data-id="element-191">
              <InstagramIcon className="w-4 h-4" data-id="element-192" />
            </a>
            <a href="#" className="text-muted hover:text-gold transition-colors" data-id="element-193">
              <TwitterIcon className="w-4 h-4" data-id="element-194" />
            </a>
            <a href="#" className="text-muted hover:text-gold transition-colors" data-id="element-195">
              <LinkedinIcon className="w-4 h-4" data-id="element-196" />
            </a>
            <a href="#" className="text-muted hover:text-gold transition-colors" data-id="element-197">
              <YoutubeIcon className="w-4 h-4" data-id="element-198" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}